import React from 'react';
import { Poppins } from 'src/common';
import * as S from './FullPageError.styles';

// PII-free fallback rendered by the top-level Sentry.ErrorBoundary when a render
// crash unmounts the page tree. It must NEVER surface the error message or component
// stack to the user — only a generic recovery prompt. The crash itself is reported to
// Sentry (with the React component stack) by the boundary.
type FullPageErrorProps = {
  onRetry?: () => void;
};

const FullPageError: React.FC<FullPageErrorProps> = ({ onRetry }) => {
  const handleRetry = (): void => {
    if (onRetry) onRetry();
    else window.location.reload();
  };

  const handleHome = (): void => {
    window.location.href = '/';
  };

  return (
    <S.Container>
      <Poppins px={28} weight={600} color="prussianBlue">
        Something went wrong
      </Poppins>
      <S.ButtonRow>
        <S.ActionButton onClick={handleHome}>Back to home</S.ActionButton>
        <S.ActionButton $primary onClick={handleRetry}>
          Try again
        </S.ActionButton>
      </S.ButtonRow>
    </S.Container>
  );
};

export default FullPageError;
